import ProfileDropdown from "../../components/ProfileDropdown";
import MobileHeader from "../../components/MobileHeader";

const Header = ({ title }) => {
    return (
        <>
            {/* Mobile layout: Use MobileHeader component for consistent design */}
            <MobileHeader screenName={title} />

            {/* Desktop layout: Title on left, Profile+Notification on right */}
            <header className="header tw-z-[49] md:tw-z-10 tw-border-b-1 tw-border-tertiary tw-bg-tertiary tw-text-white tw-hidden md:tw-flex tw-items-center">
                <div className="content-container tw-justify-between tw-text-white">
                    <div className="tw-flex tw-w-full tw-justify-between tw-items-center">
                        <div>
                            <h1 className="tw-min-w-[220px] md:headerText">{title}</h1>
                        </div>
                        <div className="tw-w-[240px] md:tw-w-auto md:tw-flex md:tw-justify-end">
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;
